function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../../framework/publisher2/tools/AbstractPublisherTool';
var BUNDLE_ID = 'maplegend';
var MapLegendTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function MapLegendTool() {
    var _this;
    _classCallCheck(this, MapLegendTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MapLegendTool, [].concat(args));
    _this.index = 10;
    _this.group = 'layers';
    return _this;
  }
  _inherits(MapLegendTool, _AbstractPublisherToo);
  return _createClass(MapLegendTool, [{
    key: "getTool",
    value: function getTool() {
      return {
        id: 'Oskari.mapframework.bundle.maplegend.plugin.MapLegendPlugin',
        title: Oskari.getMsg(BUNDLE_ID, 'tool.label'),
        config: this.state.pluginConfig || {},
        disabledReason: Oskari.getMsg(BUNDLE_ID, 'noLegendsText')
      };
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {};
    }
  }, {
    key: "init",
    value: function init(data) {
      var myData = data === null || data === void 0 ? void 0 : data.configuration[BUNDLE_ID];
      if (myData) {
        this.storePluginConf(myData.conf);
        this.setEnabled(true);
      }
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      // should we filter layers with isVisibleOnMap()?
      return !this.getSandbox().findAllSelectedMapLayers().some(function (l) {
        return l.getLegendImage();
      });
    }
  }, {
    key: "onLayersChanged",
    value: function onLayersChanged() {
      if (this.isEnabled() && this.isDisabled()) {
        // disable if layers changed and there is no longer layers with legends on map
        this.setEnabled(false);
      }
    }
  }, {
    key: "getValues",
    value: function getValues() {
      if (!this.isEnabled()) {
        return null;
      }
      return {
        configuration: _defineProperty({}, BUNDLE_ID, {
          conf: this.getPlugin().getConfig()
        })
      };
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.MapLegendTool', MapLegendTool, {
  'protocol': ['Oskari.mapframework.publisher.LayerTool']
});